import React from 'react';
import Color from 'color';
import colors from '../../../styles/colors/index.module.scss';

interface Props {
  width?: number;
  primaryColor?: string;
  secondaryColor?: string;
  avatarBackgroundColor?: string;
  className?: string;
}

export const Logo: React.FC<Props> = ({
  width = 100,
  primaryColor = colors.primary,
  secondaryColor = colors.secondary,
  avatarBackgroundColor = Color(secondaryColor).lighten(0.3).toString(),
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 553.85 103.574"
    width={width}
    height={width * (103.574 / 553.85)}
    className={className}
  >
    <defs>
      <clipPath id="a">
        <path
          d="M95.37 76.25a46.457 46.457 0 0 1-9.85 14.07c-1.87-2.22-4.63-5.33-6.31-6.45 0 0-2.72 9.02-4.81 13.9.09.1.2.24.33.43-6.47 3.43-13.86 5.37-21.69 5.37-8.38 0-16.24-2.22-23.03-6.1-.13-2.19-.4-4.55-.85-7.05-.36.13-1.33.57-1.51 1.75-.08.54-.79 1.6-1.65 2.72-1.47 1.93-3.4 4.04-3.4 4.04s-2.98 2.24-5.14 2.77c-2.16.54-3.46.24-3.46.24s-3.29-1.68-4.75-3.51c-.76-.95-1.9-2.17-2.81-3.12a8.385 8.385 0 0 1-2.25-4.52c-.31-1.98-.44-4.43-.49-5.42h-.02c-.36-.14-.36-.41-.8-.94-.46-.56-.67-.52-1.02-.91-.42-.48-.41-.88-.67-2.01a11.2 11.2 0 0 0-.4-1.39c-.19-.49-.31-.67-.37-1.31-.01-.12-.02-.23-.02-.34-.02-.87.25-1.02.17-2.12C.5 75.42.26 75 .11 74.59c-.08-.22-.14-.44-.13-.74 0-.06 0-.12.01-.18.08-.78.45-1.02.82-1.54.19-.26.38-.58.54-1.07.02-.05.03-.1.04-.14.41-1.36-.07-1.94.51-2.89.08-.13.17-.24.26-.34.45-.52 1.05-.78 1.61-1.01.01 0 .02 0 .03-.01.03-.01.06-.02.09-.04.41-.16 1.17-.35 3.63-.13h.04c.28.03.59.06.92.09.33-.46.64-1.05.77-1.78.16-.93-.1-1.39-.41-2.92-.28-1.37-.56-2.84-.3-4.51.14-.91.37-2.34 1.33-2.7.71-.26 1.49.18 1.63.26.26.15.68.46 1.11 1.37.17.36.75 1.66.59 4.92-.05 1.14-.12.94-.11 1.51.03 1.76.67 2.71 1.26 4.29.37.98 1.02 2.74 1.03 4.92 0 1.53-.31 2.85-.67 4.36-.25 1.06-.53 1.94-.74 2.58l.81.84c.67 1.16 1.44 1.68 1.44 1.68l.16-.44a98.71 98.71 0 0 0 3.75-7.64c2.33-5.33 3.5-8 3.6-8.33.17-.53.93-1.93 2.47-4.73.26-.47.77-1.37 1.7-1.59.35-.08.66-.05.87 0 3.51-.96 8.31-3.28 8.31-3.28 1.96-.54 3.68-2.64 3.68-2.64s.97-.5 1.08-1.35C39.28 48.27 38 44.93 38 44.93c-1.36-3.09-2.18-4.95-2.51-7.74v-.07c-.31-.2-.64-.44-.96-.74-1.62-1.49-2.03-3.37-2.32-4.68-.5-2.28-.19-4.13-.02-5.08.2-1.13.07-1.9.64-2.39.74-.64 1.88-.38 2.05-.35.59.13 1.03.44 1.34.73a62.44 62.44 0 0 0-1.01-4.75c-.71-2.83-1.22-4-1.48-4.93-.14-.49-.2-.91-.2-1.47.04-4.85 5.48-8.47 7.49-9.81C42.7 2.54 47.7-.68 54.28.15c1.91.24 7.52.96 10.06 5.37.54.94.84 1.87 1 2.68h.55c.05 0 .11.01.16.02.04 0 .08 0 .12.01.05 0 .11.02.17.03.04 0 .08.01.12.02.06 0 .12.02.18.04.04 0 .08.01.12.02.1.02.2.05.3.08.06.02.13.04.19.06.04.01.08.03.13.04.07.02.14.05.21.08l.09.03c.02 0 .04.01.06.02.27.12.86.38 1.46.86.38.31.77.7 1.1 1.21.74 1.16.84 2.44.73 3.62-.06.64-.18 1.25-.28 1.81-.34 1.76-.77 2.04-1.28 3.8-.3 1.04-.59 2.65-.6 4.45.78-.23 1.94-.39 3.01.25 1.44.86 1.67 2.56 1.81 3.37.27 1.56-.18 2.72-.85 4.4-.1.26-1.68 4.14-4.14 5.43-.35.18-1 .51-1.85.44-.6-.05-1.06-.28-1.32-.44 0 0-.94.49-1.58 4.29-.14.83-.59 1.75-1.21 2.66.18 1.32.58 2.24.91 2.8.04.07.08.14.12.19.04.06.07.11.11.16.04.05.07.1.1.14 0 0 0 .01.02.02.09.11.15.17.15.17.05.06.82.96 1.9 2.1 1.12 1.18 2.56 2.6 3.89 3.6.02.01 4.54 2.64 12.8 5.69 0 0 4.14.38 4.93 6.05 0 0 3.27 4.97 7.68 10.49Z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
    </defs>
    <path
      d="M143.61 62.26h24.03v-5.22h-24.03V37.38h25.8v-5.29h-31.64v56.05h32.48v-5.3h-26.64V62.26zm61.85 17.05c-1.15 1.54-2.66 2.75-4.53 3.65-1.87.9-4.06 1.34-6.57 1.34-3.28 0-5.99-.75-8.14-2.27-2.15-1.51-3.76-3.53-4.84-6.07-1.08-2.53-1.61-5.29-1.61-8.26s.54-5.77 1.61-8.26c1.08-2.48 2.67-4.45 4.8-5.91 2.12-1.46 4.8-2.19 8.02-2.19 3.74 0 6.69.93 8.87 2.8 2.18 1.87 3.49 4.21 3.95 7.03h5.53c-.31-3.07-1.28-5.73-2.92-7.99-1.64-2.25-3.78-3.99-6.41-5.22-2.64-1.23-5.64-1.84-9.02-1.84s-6.26.6-8.79 1.8c-2.53 1.2-4.65 2.82-6.34 4.84a20.925 20.925 0 0 0-3.8 6.76c-.84 2.48-1.27 5.03-1.27 7.64v1.08c0 2.56.42 5.09 1.27 7.6.84 2.51 2.11 4.8 3.8 6.87 1.69 2.07 3.8 3.71 6.34 4.91 2.53 1.2 5.52 1.8 8.95 1.8s6.42-.63 9.14-1.88c2.71-1.25 4.93-3.02 6.64-5.3s2.67-4.95 2.88-8.02h-5.53c-.21 1.84-.88 3.53-2.03 5.07Zm47.57-26.57c-1.84-2-4.08-3.6-6.72-4.8-2.64-1.2-5.67-1.8-9.1-1.8s-6.39.6-9.02 1.8c-2.64 1.2-4.88 2.8-6.72 4.8-1.84 2-3.25 4.26-4.22 6.8-.97 2.53-1.46 5.11-1.46 7.72v1.08c0 2.61.47 5.17 1.42 7.68s2.33 4.77 4.15 6.8c1.82 2.02 4.04 3.64 6.68 4.84 2.64 1.2 5.69 1.8 9.18 1.8s6.55-.6 9.21-1.8c2.66-1.2 4.9-2.81 6.72-4.84 1.82-2.02 3.19-4.29 4.11-6.8.92-2.51 1.38-5.07 1.38-7.68v-1.08c0-2.61-.47-5.18-1.42-7.72a20.56 20.56 0 0 0-4.19-6.8Zm-1.92 23.31a14.911 14.911 0 0 1-5.34 5.99c-2.33 1.51-5.18 2.27-8.56 2.27s-6.16-.75-8.49-2.27a14.911 14.911 0 0 1-5.34-5.99c-1.23-2.48-1.84-5.23-1.84-8.26s.63-5.85 1.88-8.33c1.25-2.48 3.06-4.45 5.41-5.91s5.15-2.19 8.37-2.19 6.09.73 8.45 2.19c2.35 1.46 4.16 3.43 5.41 5.91s1.88 5.26 1.88 8.33-.61 5.77-1.84 8.26Z"
      style={{
        fill: secondaryColor,
      }}
    />
    <path
      d="M299.25 59.33c1.18-.75 2.19-1.65 3.05-2.71 1.66-2.07 2.5-4.85 2.5-8.33v-1.15c0-4.96-1.65-8.78-4.95-11.44-3.3-2.66-8.13-3.99-14.48-3.99h-20.12v56.83h22.42c4.25 0 7.82-.63 10.71-1.88 2.89-1.25 5.07-3.05 6.53-5.38s2.19-5.16 2.19-8.49v-1.08c0-3.53-.83-6.35-2.5-8.45-1.36-1.71-3.14-3.02-5.35-3.93Zm-12.89-18.87c2.61 0 4.53.69 5.76 2.07 1.23 1.38 1.84 3.25 1.84 5.61s-.61 4.07-1.84 5.45-3.15 2.07-5.76 2.07h-10.44v-15.2h10.44Zm7.87 37.2c-1.36 1.41-3.29 2.11-5.8 2.11h-12.52V64.1h12.52c2.56 0 4.5.68 5.84 2.03 1.33 1.36 2 3.26 2 5.72s-.68 4.39-2.03 5.8Zm44.5-6.64c0 2.71-.78 4.86-2.34 6.45-1.56 1.59-3.57 2.38-6.03 2.38s-4.4-.75-5.84-2.27c-1.43-1.51-2.15-3.54-2.15-6.1V46.37H311.7v24.19c0 6.3 1.31 11.02 3.92 14.17 2.61 3.15 6.35 4.72 11.21 4.72h.46c3.23 0 5.9-.7 8.02-2.11 2.12-1.41 3.74-3.52 4.84-6.34.31-.8.58-1.67.81-2.59v9.73h8.45V46.37h-10.67v24.65Zm29.64-36.32h-10.06v11.75h-6.6v7.83h6.6v18.2c0 4.04.6 7.26 1.8 9.64 1.2 2.38 3.05 4.07 5.53 5.07 2.48 1 5.67 1.5 9.56 1.5h5.99v-9.14h-6.53c-2.05 0-3.62-.55-4.72-1.65-1.1-1.1-1.65-2.67-1.65-4.72l.04-18.89h12.86v-7.83h-12.85l.02-11.75Zm12.52-2.61v7.98h5.22v48.07h10.67V32.09h-15.89zm53.02 15.85c-3.05-1.97-6.82-2.96-11.33-2.96-3.43 0-6.46.6-9.1 1.8-2.64 1.2-4.83 2.82-6.57 4.84a20.977 20.977 0 0 0-3.95 6.91c-.9 2.59-1.34 5.26-1.34 8.02v1.46c0 2.66.45 5.27 1.34 7.83.9 2.56 2.23 4.88 3.99 6.95 1.77 2.07 3.99 3.72 6.68 4.95 2.69 1.23 5.82 1.84 9.41 1.84s6.49-.59 9.18-1.77c2.69-1.18 4.9-2.84 6.64-4.99 1.74-2.15 2.92-4.66 3.53-7.53h-9.91c-.46 1.54-1.51 2.83-3.15 3.88-1.64 1.05-3.74 1.57-6.3 1.57s-4.76-.58-6.45-1.73c-1.69-1.15-2.94-2.74-3.76-4.76-.53-1.32-.89-2.77-1.08-4.34h31.33v-3.92c0-3.69-.77-7.13-2.3-10.33-1.54-3.2-3.83-5.78-6.87-7.76Zm-17.32 7.53c1.64-1.1 3.63-1.65 5.99-1.65s4.3.51 5.84 1.54c1.54 1.02 2.7 2.48 3.49 4.38.45 1.08.77 2.28.96 3.61h-20.94c.21-1.17.52-2.25.93-3.23.84-2 2.09-3.54 3.72-4.65Zm55.68-.27v-9.29h-1.54c-4.97 0-8.73 1.55-11.29 4.65-1.93 2.34-3.14 5.49-3.61 9.46V46.46h-8.45v41.7h10.67V66.5c0-3.63.99-6.42 2.96-8.37 1.97-1.94 4.75-2.92 8.33-2.92h2.92Z"
      style={{
        fill: primaryColor,
      }}
    />
    <path
      d="M467.51 82.47h5.05v5.15h-5.05zm18.15.32c-.33.49-.78.88-1.33 1.16-.56.28-1.23.42-2.03.42-1.01 0-1.84-.24-2.49-.71-.65-.47-1.14-1.13-1.45-1.96-.31-.84-.47-1.77-.47-2.8s.16-2.02.48-2.85c.32-.83.81-1.47 1.46-1.95.65-.47 1.46-.71 2.43-.71 1.16 0 2.06.31 2.7.92a3.64 3.64 0 0 1 1.13 2.23h4.37c-.09-1.39-.49-2.62-1.21-3.67-.72-1.05-1.68-1.87-2.88-2.46-1.2-.59-2.57-.88-4.12-.88-1.46 0-2.74.25-3.84.76-1.1.5-2.03 1.18-2.77 2.03a8.61 8.61 0 0 0-1.67 2.89c-.38 1.08-.56 2.21-.56 3.39v.61c0 1.11.18 2.21.55 3.28.36 1.07.91 2.04 1.64 2.91.73.87 1.65 1.55 2.77 2.06 1.11.5 2.42.76 3.92.76s2.95-.3 4.16-.9c1.21-.6 2.19-1.43 2.93-2.49.74-1.06 1.15-2.3 1.24-3.71h-4.37c-.06.62-.26 1.18-.59 1.67Zm22-10.53c-.83-.85-1.83-1.51-3.01-1.99-1.18-.48-2.51-.72-3.99-.72s-2.81.24-4 .72-2.2 1.15-3.02 1.99c-.83.85-1.45 1.81-1.88 2.89a9.156 9.156 0 0 0-.64 3.42v.68c0 1.18.21 2.3.63 3.38a8.383 8.383 0 0 0 1.85 2.86c.81.84 1.81 1.5 2.99 1.99 1.18.49 2.54.74 4.08.74s2.87-.25 4.05-.74c1.18-.49 2.18-1.16 2.99-1.99.81-.84 1.43-1.79 1.85-2.86.42-1.07.63-2.2.63-3.38v-.68c0-1.2-.21-2.34-.64-3.42a8.74 8.74 0 0 0-1.88-2.89Zm-2.54 9.46c-.4.83-.97 1.48-1.72 1.96s-1.66.72-2.73.72-2.02-.24-2.77-.72-1.32-1.14-1.72-1.96c-.4-.83-.59-1.76-.59-2.81s.2-1.99.61-2.83c.41-.84.99-1.5 1.75-1.98s1.67-.72 2.72-.72 1.95.24 2.7.72a4.79 4.79 0 0 1 1.74 1.98c.41.84.61 1.78.61 2.83s-.2 1.99-.59 2.81Zm5.93.75h5.05v5.15h-5.05zm17.85-2.03c0 1.14-.33 2.04-.98 2.7-.65.66-1.5 1-2.52 1s-1.84-.32-2.44-.95c-.6-.63-.9-1.48-.9-2.56V70.11h-4.47v10.13c0 2.64.55 4.61 1.64 5.93 1.09 1.32 2.66 1.98 4.69 1.98h.19c1.35 0 2.47-.29 3.36-.88.89-.59 1.56-1.47 2.03-2.65.13-.34.24-.7.34-1.09v4.08h3.54V70.12h-4.47v10.32Zm17.6-2.84 5.93-7.45h-4.66l-6.72 8.41V64.14h-4.47v23.48h4.47v-8.17h1.9l5.85 8.17h5.05L546.5 77.6z"
      style={{
        fill: secondaryColor,
      }}
    />
    <circle
      cx={53.05}
      cy={57.15}
      r={46.42}
      style={{
        fill: avatarBackgroundColor,
      }}
    />
    <path
      d="M30.02 97.47c-1.38-.79-2.72-1.65-4.01-2.58.86-1.13 1.57-2.18 1.65-2.72.18-1.18 1.14-1.62 1.51-1.75.45 2.5.72 4.86.85 7.05Zm55.51-7.15a46.5 46.5 0 0 1-10.79 7.89c-.14-.19-.25-.33-.33-.43 2.09-4.88 4.81-13.9 4.81-13.9 1.68 1.11 4.44 4.23 6.31 6.45Z"
      style={{
        fill: avatarBackgroundColor,
      }}
    />
    <g
      style={{
        clipPath: "url(#a)",
      }}
    >
      <path
        d="M73.1 103.73c.04-.09.22-3.27 0-3.79s1.11-2.38 1.11-2.38.24.22.65.81.52 2.27.52 2.27 1.5 3.75 2.27 4.46l.56.11-1.78.45-2.9-.52-.43-1.4Z"
        style={{
          fill: "#d69569",
        }}
      />
      <path
        d="M73.32 103.1c1.3.02 2.6.52 3.59 1.36-1.16-.58-2.33-1.03-3.59-1.36Z"
        style={{
          fill: "#b27d59",
        }}
      />
      <path
        d="M105.05 90.51s-1.55-4.66-7.17-11.24S87.7 65.76 87.7 65.76c-.79-5.67-4.93-6.05-4.93-6.05l-2.62.8-2.38 3.44-1.17 5.21-1.38 7.1 1.66 6.45 1.62 1.77.72-.61c2.73 1.81 8.29 8.87 8.29 8.87.02 2.37-8.86 11.66-8.86 11.66 3.64.46 8.36 8.84 8.36 8.84l-1.55 1.33 1.05.81c.25.19.6.17.82-.04l.46-.43c.08-.07.19-.08.28-.01l.19.15c.33.27.83.21 1.09-.13 3.6-4.8 6.63-8.5 6.63-8.5s7.99-7.69 8.95-10.98c.96-3.29.15-4.92.15-4.92Z"
        style={{
          fill: "#1e1c1d",
        }}
      />
      <path
        d="M76.8 72.8c-1.08 11.46 2.42 11.07 2.42 11.07s-3.57 11.84-5.67 15.73c-4.59 8.48 1.38 17.72 1.38 17.72H42.69s-3.04-11.43-.93-19.9l4.92-7.39 15.58-25.04 2.96-8.07 4.75-2.89s4.52 2.63 12.8 5.69c0 0-4.88 1.63-5.97 13.09Z"
        style={{
          fill: "#101010",
        }}
      />
      <path
        d="M5 85.74s1.05 2.44 3.16 2.49 4.56-3.19 4.56-3.19 1.82-2.81 1.49-4.56c-.33-1.75-.69-2.12-.69-2.12l1.32 1.37.76 1.92-.52 4.23-2.38 4.01-4.2 3.33-1.85-.31-1.82-4.66-.63-3.08.8.58Z"
        style={{
          fill: "#f1f2f2",
        }}
      />
      <ellipse
        cx={8.62}
        cy={90.22}
        rx={1.1}
        ry={1.01}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <ellipse
        cx={8.68}
        cy={90.16}
        rx={0.8}
        ry={0.74}
        style={{
          fill: "#f1f2f2",
        }}
      />
      <circle
        cx={8.53}
        cy={89.99}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <circle
        cx={8.87}
        cy={89.94}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <circle
        cx={8.96}
        cy={90.29}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <circle
        cx={8.6}
        cy={90.39}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <path
        d="M28.81 58.67c-.21-.05-.52-.08-.87 0-.93.22-1.44 1.12-1.7 1.59-1.53 2.8-2.3 4.2-2.46 4.73-.1.33-1.27 3-3.6 8.33a98.71 98.71 0 0 1-3.75 7.64l-.16.44s-.78-.52-1.44-1.68c0 0 .85 3.48-.2 5.79s-2.27 3.97-2.27 3.97-1.57 1.81-2.77 2.38-1.79.91-2.46.65c-.54-.21-2-4.53-2.54-6.15-.13-.4-.2-.82-.2-1.24v-.35l-.68.15s.11 3.33.51 5.87c.26 1.7 1.05 3.28 2.25 4.52.91.95 2.05 2.17 2.81 3.12 1.46 1.83 4.75 3.51 4.75 3.51s1.29.3 3.46-.24c2.16-.54 5.14-2.77 5.14-2.77s4.83-5.31 5.05-6.77c.22-1.46 1.65-1.79 1.65-1.79l-.43-8.08-.13-9.74.63-12.9-.57-.98Z"
        style={{
          fill: "#1e1c1d",
        }}
      />
      <path
        d="M16.61 81.97c2.83 2.34 5.08 5.9 5.99 9.45a92.927 92.927 0 0 0-5.99-9.45Z"
        style={{
          fill: "#101010",
        }}
      />
      <path
        d="M20.01 86.52c1.51 0 4.16.79 4.89 2.22-1.59-.85-3.36-1.22-4.89-2.22Z"
        style={{
          fill: "#101010",
        }}
      />
      <path
        d="M15.43 71.95c-.01-2.18-.67-3.94-1.04-4.92-.59-1.58-1.22-2.53-1.26-4.29-.01-.57.06-.38.11-1.52.15-3.26-.42-4.56-.59-4.92-.43-.91-.85-1.22-1.11-1.37-.14-.08-.92-.52-1.63-.26-.96.36-1.19 1.79-1.33 2.7-.26 1.67.02 3.14.3 4.51.31 1.53.57 1.99.41 2.92a4.29 4.29 0 0 1-.77 1.78c-3.45-.39-4.24-.12-4.68.06-.69.29-1.43.6-1.9 1.37-.6.97-.06 1.56-.55 3.03-.5 1.49-1.24 1.45-1.37 2.61-.11 1.02.46 1.15.57 2.68.09 1.23-.26 1.27-.15 2.46.1 1.03.36.87.78 2.7.26 1.13.24 1.54.67 2.02.34.39.55.35 1.02.91.44.53.44.8.8.94.29.11.65.08.8.34.03.06.04.11.05.13.37.97 1.19 1.49 1.61 1.76.59.37 1.38.87 2.41.79.86-.07 1.42-.5 2.23-1.12.54-.42 1.62-1.27 2.47-2.81.42-.77 1.21-2.19 1.04-4.09-.05-.55-.16-1.03-.3-1.43.22-.64.5-1.53.75-2.62.36-1.51.67-2.83.67-4.36Z"
        style={{
          fill: "#d69569",
        }}
      />
      <path
        d="M13.44 76.44c.09-.12.82-1.11.5-2.33-.15-.58-.49-1-.78-1.26l-.05-.05a.55.55 0 0 0 .07-.09c.04-.05.11-.14.18-.26.3-.45.75-1.33.6-2.46 0 0-.19-1.38-1.35-2.31-.06-.04-.1-.08-.13-.1-.75-.54-1.49-.66-1.91-.72-.77-.11-1.45-.2-2.05-.27-3.45-.39-4.24-.12-4.68.06-.69.29-1.43.6-1.9 1.37-.6.98-.06 1.57-.56 3.03C.88 72.54.14 72.5.01 73.66c-.11 1.02.46 1.15.57 2.68.09 1.23-.26 1.27-.15 2.46.1 1.03.36.87.78 2.7.26 1.13.24 1.54.66 2.01.34.39.55.34 1.02.91.44.53.44.8.8.94.07.03.14.04.21.06 1.62-.03 5.44-.4 6.25-.61.36-.1.64-.19.96-.39 1.21-.76 1.43-2.17 1.48-2.46.04-.24.14-.72 0-1.01a.364.364 0 0 0-.12-.15.361.361 0 0 0-.25-.06c.06-.06.13-.13.19-.2.24-.28.46-.6.6-.99.09-.25.51-1.37-.04-2.09-.02-.02-.04-.05-.06-.07-.07-.07-.16-.15-.3-.22.11-.06.23-.14.34-.23.17-.14.34-.3.48-.5Z"
        style={{
          fill: "#db9f6a",
        }}
      />
      <path
        d="M13.18 72.71s-.05.06-.07.09c.02.02.04.03.05.05-.49-.42-1.08-.67-1.73-.78-.71-.13-1.44-.2-2.17-.27-.72-.08-1.47-.08-2.19-.23-.73-.16-1.4-.49-2-.91.62.39 1.3.68 2.02.8.72.11 1.45.08 2.19.12 1.37.1 2.93.01 4.08.87-.07.12-.14.21-.18.26Zm-.57 4.45c.14.08.23.15.3.22-.02 0-.04 0-.06-.02-1.33-.58-2.86-.57-4.29-.65-1.48-.04-3-.09-4.33-.84 1.36.68 2.85.65 4.33.62 1.46 0 2.97-.08 4.38.44-.11.09-.22.16-.34.23Zm-.01 3.79h-.01c-.3.02-.66.2-.98.28-1.07.23-2.13.08-3.22.11-1.41 0-2.83-.17-4.2-.49 1.39.25 2.79.34 4.2.27 1.02-.08 2.12 0 3.1-.26.33-.1.58-.26.93-.33-.06.07-.12.14-.19.2.1 0 .18.01.25.06.05.04.09.09.12.15Z"
        style={{
          fill: "#b27d59",
        }}
      />
      <path
        d="M37.12 55.38s-4.8 2.32-8.31 3.28c0 0-3.35 11.68.31 31.48 3.15 17.01-2.07 27.17-2.07 27.17h17.01l-1.55-7.87-.22-10.94 1.77-4.44-2.55-1.37-6.66-17.04-.55-11.79 3.03-4.21-.26-2.14.06-2.11Z"
        style={{
          fill: "#161616",
        }}
      />
      <path
        d="m64.18 48.32-.09.07-13.47 10.83-1.11-.28-3.6-.92-3.38-3.9c.15-1.63-.32-3.87-.32-3.87l4.31.76 7.52-.59 8.63-7.03c0 2.1.57 3.48 1.01 4.23.08.14.16.26.23.36.16.23.27.34.27.34Z"
        style={{
          fill: "#d69569",
        }}
      />
      <path
        d="m40.67 63.63-2.96 2.12.59 18.19 4.83 8.48 4.39-3.26 12.92-26.57-1.83-3.5-8.82 1.68-6.02.15-3.1.64v2.07z"
        style={{
          fill: "#e6e7e8",
        }}
      />
      <path
        d="M64.89 49.63s-.07-.28-.32-.68l-.03-.18-.32-.39-.02-.02s-.01-.02-.02-.02c-.01-.01-.12-.13-.27-.34-.07-.1-.14-.22-.23-.36-.43.81-3.38 5.57-15.36 10.34 0 0 .48.37 1.2.97 1.87 1.55 5.37 4.58 6.13 6.29 0 0 1.08-.71 2.47-2.13 1.19-1.2 2.61-2.91 3.8-5.12l3.39-6.13-.42-2.21ZM50.45 63.45s-5.67 12.23-3.99 26.52l-.71 2.97-3.33 1.47v-3.77c-1.43-20.78 4.41-27.99 4.41-27.99l.81-.85 2.02.12.79 1.53Z"
        style={{
          fill: "#f1f2f2",
        }}
      />
      <ellipse
        cx={46.27}
        cy={68.82}
        rx={1.1}
        ry={1.01}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <ellipse
        cx={46.34}
        cy={68.75}
        rx={0.8}
        ry={0.74}
        style={{
          fill: "#f1f2f2",
        }}
      />
      <circle
        cx={46.18}
        cy={68.59}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <circle
        cx={46.52}
        cy={68.54}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <circle
        cx={46.61}
        cy={68.88}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <circle
        cx={46.25}
        cy={68.99}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <ellipse
        cx={44.75}
        cy={78.21}
        rx={1.1}
        ry={1.01}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <ellipse
        cx={44.81}
        cy={78.15}
        rx={0.8}
        ry={0.74}
        style={{
          fill: "#f1f2f2",
        }}
      />
      <circle
        cx={44.66}
        cy={77.99}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <circle
        cx={45}
        cy={77.94}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <circle
        cx={45.09}
        cy={78.28}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <circle
        cx={44.73}
        cy={78.38}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <ellipse
        cx={44.01}
        cy={87.61}
        rx={1.1}
        ry={1.01}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <ellipse
        cx={44.08}
        cy={87.55}
        rx={0.8}
        ry={0.74}
        style={{
          fill: "#f1f2f2",
        }}
      />
      <circle
        cx={43.93}
        cy={87.39}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <circle
        cx={44.27}
        cy={87.34}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <circle
        cx={44.35}
        cy={87.68}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <circle
        cx={44}
        cy={87.78}
        r={0.1}
        style={{
          fill: "#e6e7e8",
        }}
      />
      <path
        d="M40.8 52.74s1.09-.56 1.09-1.5l.69.8s-1.05 3.23 5.73 5.92l-.28 1.36-4.89-.43-3.68-1.74 1.35-4.42Z"
        style={{
          fill: "#f1f2f2",
        }}
      />
      <path
        d="M36.46 37.59c-.5-.22-1.21-.6-1.9-1.23-1.62-1.49-2.03-3.37-2.32-4.68-.5-2.28-.19-4.13-.02-5.08.2-1.13.08-1.9.64-2.39.74-.64 1.88-.38 2.05-.35 1.14.26 1.73 1.16 1.85 1.36"
        style={{
          fill: "#d69569",
        }}
      />
      <path
        d="M38.59 34.57c.09-.35.06-.73-.09-1.02-.3-.44-.66-.87-.92-1.35-.23-.37-.24-.94.11-1.26.1-.13.17-.25.24-.4l-.03.14c0-.09.05-.17.08-.25.25-.57.22-1.15-.03-1.74a4.398 4.398 0 0 0-2.39-2.42c-.79-.39-1.24-.19-1.51.66a6.75 6.75 0 0 0 .09 4.05c.44 1.33 1.29 2.53 2.27 3.62-.3-.21-.58-.45-.85-.7-1.7-1.51-2.77-3.76-2.53-6.07.07-1 .4-2.38 1.59-2.62.68-.11 1.26.23 1.83.52 1.59.9 3.04 3.14 2.1 4.95l-.05.1v.02h-.01c0-.02.03-.09.03-.13-.04.24-.24.45-.4.63-.13.13-.16.15-.19.31 0 .59.54 1.29.78 1.87.13.38.06.77-.09 1.1Z"
        style={{
          fill: "#c68b60",
        }}
      />
      <path
        d="M72.86 32.42c-.1.26-1.68 4.14-4.14 5.43-.35.18-1 .51-1.85.44-.6-.05-1.06-.28-1.33-.44 0 0-.94.49-1.58 4.29-.64 3.8-7.69 9.22-7.69 9.22s-5.72 3.89-8.58 3.5c-2.86-.4-3.75-1.13-5.13-2.66-3.02-3.35-4.53-7.3-4.53-7.3-1.36-3.09-2.18-4.95-2.51-7.74-.36-2.98-.05-5.9.3-7.54l.59-2.81-.04-1.37c.22-.5.4-1.08.51-1.73.15-.95.04-1.47 0-2.4-.1-2.13.27-3.69.85-6.14.56-2.35 1.02-3.16 1.63-3.81.09-.1.52-.54 1.26-1 1.52-.93 3.22-1.21 6.51-1.22 2.18 0 2.02.12 4.29.15 4.11.05 6.15-.32 8.91.63.8.28 1.43.58 1.92 1.18.53.64.64 1.67.85 3.7.35 3.39.38 3.76.59 4.47.43 1.5.72 1.39 1.03 2.74.31 1.3.27 2.37.22 3.96-.07 2.02-.31 2.93.33 3.92.07.11.16.24.26.35.06.07.12.13.18.19.14 0 .25-.02.27-.08.02-.06-.04-.13-.06-.14-.22-.26-.57-3.95 2.05-5.42.05-.03.39-.22.9-.37.78-.24 1.94-.39 3.01.24 1.44.86 1.67 2.56 1.81 3.36.27 1.56-.18 2.72-.85 4.4Z"
        style={{
          fill: "#db9f6a",
        }}
      />
      <path
        d="M70.78 16.16c-.34 1.76-.78 2.04-1.28 3.8-.3 1.04-.59 2.65-.6 4.45-.5.16-.85.34-.9.37-2.62 1.47-2.27 5.17-2.05 5.42.01.01.08.08.06.14-.02.06-.14.08-.27.08a3.32 3.32 0 0 1-.18-.19c-.1-.11-.19-.24-.26-.35-.65-.99-.4-1.9-.33-3.92.05-1.58.09-2.65-.22-3.96-.32-1.35-.6-1.24-1.03-2.74-.21-.71-.24-1.08-.59-4.47-.21-2.03-.32-3.06-.85-3.7-.49-.6-1.12-.91-1.92-1.18-2.76-.95-4.8-.58-8.91-.63-2.27-.03-2.11-.15-4.29-.15-3.29 0-4.99.29-6.51 1.22-.74.46-1.16.9-1.26 1-.61.65-1.07 1.46-1.63 3.81-.58 2.45-.95 4-.85 6.14.04.93.15 1.45 0 2.4-.11.65-.29 1.23-.51 1.73-.23-1.47-.59-3.39-1.15-5.6-1.09-4.31-1.69-4.77-1.67-6.4.04-4.85 5.48-8.47 7.49-9.81 1.68-1.11 6.68-4.34 13.26-3.5 1.91.24 7.52.96 10.06 5.37.54.94.84 1.87 1.01 2.68.65 0 1.49.1 2.4.48.45.19 1.72.75 2.56 2.07 1.15 1.8.75 3.85.44 5.42Z"
        style={{
          fill: "#311c07",
        }}
      />
      <path
        d="M70.78 16.16c-.34 1.76-.78 2.04-1.28 3.8-.3 1.04-.59 2.65-.6 4.45-.5.16-.85.34-.9.37-2.62 1.47-2.27 5.17-2.05 5.42.01.01.08.08.06.14-.02.06-.13.08-.27.08a3.32 3.32 0 0 1-.18-.19c-.1-.11-.19-.24-.26-.35-.64-.99-.4-1.9-.33-3.92.05-1.58.09-2.65-.22-3.96-.32-1.35-.6-1.24-1.03-2.74-.21-.71-.24-1.08-.59-4.47-.18-1.77-.3-2.77-.67-3.42-.06-.1-.12-.19-.18-.27-.12-.15-.25-.28-.39-.4.89-1.74 2.32-2.36 3.6-2.53.62 0 1.41.11 2.26.46.02 0 .04.01.06.02.45.19 1.72.75 2.56 2.07 1.15 1.8.75 3.85.44 5.42Z"
        style={{
          fill: "#4f2c0c",
        }}
      />
      <path
        d="M68.13 28.04s2.1.37 2.27 2.4-2.53 3.2-2.53 3.2l.38-.79.1-.6-.04-.58-.36-.7-.36-.91.28-1.48.26-.54Z"
        style={{
          fill: "#c68b60",
        }}
      />
      <path
        d="M67.4 35.23c-.15-.33-.22-.72-.09-1.1.23-.58.79-1.27.78-1.87-.03-.16-.07-.18-.19-.31-.16-.18-.36-.38-.4-.63 0 .04 0 .09.03.13-.04-.08-.09-.19-.12-.26-.82-1.78.62-3.93 2.16-4.81.57-.29 1.15-.63 1.83-.52 1.59.38 1.64 2.46 1.6 3.77-.11 1.92-1.15 3.66-2.54 4.92-.27.25-.56.48-.85.7.98-1.09 1.82-2.29 2.27-3.62.45-1.28.47-2.78.09-4.05-.28-.85-.72-1.05-1.51-.66a4.43 4.43 0 0 0-2.39 2.42c-.25.59-.28 1.16-.03 1.74.03.08.08.16.08.25l-.03-.14c.07.15.14.27.24.4.34.32.33.89.1 1.26-.26.48-.62.91-.92 1.35-.15.29-.18.67-.09 1.02Z"
        style={{
          fill: "#b27d59",
        }}
      />
      <ellipse
        cx={43.3}
        cy={26.05}
        rx={3.6}
        ry={3.37}
        style={{
          fill: "#fff",
        }}
      />
      <ellipse
        cx={44.46}
        cy={26.27}
        rx={1.86}
        ry={2.1}
        style={{
          fill: "#3c2415",
        }}
      />
      <ellipse
        cx={44.46}
        cy={26.03}
        rx={0.8}
        ry={0.9}
        style={{
          fill: "#231f20",
        }}
      />
      <ellipse
        cx={45.41}
        cy={25.02}
        rx={0.32}
        ry={0.36}
        style={{
          fill: "#fff",
        }}
        transform="rotate(-32.4 45.414 25.026)"
      />
      <ellipse
        cx={54.81}
        cy={26.51}
        rx={3.92}
        ry={3.67}
        style={{
          fill: "#fff",
        }}
      />
      <ellipse
        cx={54.91}
        cy={26.75}
        rx={2.02}
        ry={2.28}
        style={{
          fill: "#3c2415",
        }}
      />
      <ellipse
        cx={54.91}
        cy={26.49}
        rx={0.86}
        ry={0.98}
        style={{
          fill: "#231f20",
        }}
      />
      <ellipse
        cx={55.93}
        cy={25.39}
        rx={0.35}
        ry={0.4}
        style={{
          fill: "#fff",
        }}
        transform="rotate(-32.4 55.944 25.398)"
      />
      <path
        d="M51.54 23.56c1.21-2.27 4.64-2.56 6.09-.38-.55-.2-1.07-.38-1.58-.49-1.6-.38-3.08.14-4.52.87Z"
        style={{
          fill: "#b27d59",
        }}
      />
      <path
        d="M50.89 18.67c3.04-2.76 8.33-1.34 9.33 2.71-.72-.6-1.39-1.15-2.1-1.59-2.19-1.43-4.69-1.45-7.23-1.12Zm-4.74.01c-2.69-2.39-7.32-1.09-8.16 2.47.63-.54 1.21-1.02 1.82-1.41 1.91-1.28 4.1-1.32 6.34-1.06Z"
        style={{
          fill: "#d69569",
        }}
      />
      <path
        d="M46.49 23.4c-1.4-.73-2.85-1.26-4.42-.87-.5.11-1 .29-1.55.49 1.41-2.19 4.8-1.89 5.97.38Z"
        style={{
          fill: "#b27d59",
        }}
      />
      <path
        d="M61.31 20.75c.03.19-.19.3-.33.18-1.04-.99-2.82-2.34-5.37-2.95-1.93-.46-3.61-.33-4.71-.14a.195.195 0 0 1-.23-.16c-.09-.52-.14-1.14-.07-1.85.03-.28.08-.54.14-.79.12-.5.57-.85 1.09-.87.75-.02 1.63.02 2.6.18 1.26.21 2.85.46 4.19 1.46 1.85 1.36 2.47 3.53 2.69 4.94Zm-24.06-.1c-.03.18.14.31.27.19.92-.94 2.49-2.2 4.66-2.69 1.64-.37 3.04-.16 3.95.09.09.02.18-.04.2-.15.11-.51.19-1.13.16-1.84-.01-.28-.04-.55-.07-.8-.07-.51-.43-.88-.86-.92a9.56 9.56 0 0 0-2.18.05c-1.06.15-2.41.33-3.59 1.26-1.62 1.27-2.27 3.41-2.53 4.8Z"
        style={{
          fill: "#311c07",
        }}
      />
      <path
        d="M41.24 40.58c2.92 1.45 6.01 2.51 9.38 1.96 2.05-.31 3.73-1.02 5.64-1.87-.64 1.09-1.71 2.01-3 2.68-4.11 2.19-9.91.84-12.02-2.77Z"
        style={{
          fill: "#d69569",
        }}
      />
      <path
        d="M58.01 38.98c-1.18 1.43-2.79 2.52-4.49 3.29-4.51 2.01-10.04 1.42-13.18-2.67l.45.36c1.08.97 2.82 2.21 5.22 2.76 5.79 1.34 10.53-2.44 11.89-3.66.04-.03.07-.06.11-.08Z"
        style={{
          fill: "#b27d59",
        }}
      />
      <path
        d="M57.89 39.06c-1.35 1.23-6.1 5-11.89 3.66-2.39-.55-4.14-1.79-5.22-2.76 2.38 1.84 5.39 2.81 8.4 2.49 3.16-.23 6.15-1.51 8.71-3.4Zm-2.53-1.55c1.96-1.06 4.82.39 4.9 2.67a6.51 6.51 0 0 0-.92-1.18c-1.05-1.06-2.5-1.46-3.98-1.49Zm-16.4 2.35c.21-1.18 1.89-1.72 2.74-.87-1.08-.16-1.98.13-2.74.87Z"
        style={{
          fill: "#c68b60",
        }}
      />
      <path
        d="M49.84 25.35s-.6-4.09-2.45-5.78c-.2-.18-.41-.35-.41-.35-.24-.18-.51-.37-.84-.55.5.62 1.01 1.46 1.29 2.52.7 2.66-.49 5.13-.99 6.16-.55 1.14-1.13 1.84-2.71 4.88-.31.59-.63 1.23-.59 2.07.08 1.55 1.31 2.6 1.63 2.86 1.52 1.28 3.37 1.27 4.27 1.17-.04-.68.34-1.33.91-1.55.51-.19 1.14-.03 1.57.4.15-.1.31-.22.48-.37 0 0 .41-.37.69-.81.25-.39.36-.93.37-1.54 0-.34-.03-.69-.1-1.04-.59-.61-1.32-.96-2.05-.92-.2 0-.37.05-.37.05-.07.02-.08.02-.08.02-.23 0-.13-3.82-.63-7.21Zm-.63 13.91c-.07.02-.25.05-.51.08l.51-.08Z"
        style={{
          fill: "#d69569",
        }}
      />
      <path
        d="M45.58 31.93c-.98 2.43.68 3.98 3.06 4.09-.53.24-1.14.3-1.74.17-2.06-.42-2.88-2.79-1.32-4.26Zm3.43.66c1.36-1.19 3.92-.41 4.19 1.43-.3-.3-.6-.55-.91-.76-.98-.65-2.11-.77-3.27-.68Z"
        style={{
          fill: "#c68b60",
        }}
      />
      <path
        d="m60.39 75.17-1.63 1.96.81.68 10.17-.96.18-1.79c.01-.14-.1-.25-.23-.24-1.03.07-4.98.33-9.3.35Z"
        style={{
          fill: "#f1f2f2",
        }}
      />
      <path
        d="M59.15 77.18s8.33-.37 11.93-.93c.11-.02.2.07.2.17-.01.48-.09 1.76-.55 3-.07.18-.22.32-.41.37-1.12.28-5.51 1.18-14.18.99l3.01-3.6Z"
        style={{
          fill: "#191617",
        }}
      />
      <path
        d="M40.8 52.74s-1.72 2.11-3.68 2.64c0 0-.98 2.16-2.33 3.44l1.35 1.63s-2.42 1.57-3.68 2.55c0 0-2.53 19.02 10.34 31.99l.51-1.87s-7.3-17.45-3.25-29.09l1.33-7.05-.79-.6.2-3.65Z"
        style={{
          fill: "#231f21",
        }}
      />
      <path
        d="M54.99 65.13c-.15.22-.41.34-.68.32-.32-.02-.7-.07-1.13-.18-1.14-.29-1.95-.83-2.7-1.35-.39-.27-.83-.6-1.29-1.02 0 0-.69-2.17.33-4.21.34-.26.86-.62 1.53-.97.99-.52 1.96-1.04 3.23-1.04.4 0 1.03.05 1.79.34.15.06.26.19.27.35.03.3.04.6.05.9-.07 2.86-.37 5.4-1.41 6.87ZM39.95 64.1c.11.24.34.41.6.44.32.04.7.06 1.14.04 1.18-.07 2.07-.45 2.9-.82.43-.19.93-.44 1.46-.76 0 0 1.09-2 .47-4.2-.29-.32-.73-.77-1.32-1.24-.87-.7-1.73-1.39-2.97-1.63a4.71 4.71 0 0 0-1.82 0c-.16.03-.29.14-.33.3-.08.29-.15.59-.22.87-.47 2.83-.66 5.38.08 7.01Z"
        style={{
          fill: "#191617",
        }}
      />
      <path
        d="M49.2 62.89c-1.07.34-1.85.31-2.39.17-.6-.16-1.07-.62-1.24-1.22-.26-.88-.51-2.43.56-3.36 1.55-1.35 3.41.2 3.41.2-1.02 2.04-.33 4.21-.33 4.21Z"
        style={{
          fill: "#101010",
        }}
      />
      <path
        d="M64.18 48.32s3.13 3.71 5.79 5.71c0 0 .26 3.7-.41 5.62 0 0-3.11 1.55-4.25 1.85l2.03 2.26s.81.89.3 1.63-12.28 18.96-25.88 32.04c2.42-14.32 25.35-45.91 22.42-49.1Z"
        style={{
          fill: "#1e1c1d",
        }}
      />
      <path
        d="M84 113.69c.02.28-.59.88-.59.88s-3.06 1.96-3.11 2.75H67.56c.66-.41 1.33-.82 1.99-1.23 1.74-1.1 2.58-1.7 2.52-1.8-.06-.11-1.23.39-3.49 1.52-.84.5-1.68 1.01-2.51 1.52h-5.1c.73-1.13 1.5-1.72 2.07-2.05.4-.23.9-.44 1.46-.98.52-.49 1.17-1.11 1.59-1.41 1.53-1.07 1.44-.41 3.55-1.81.51-.34.89-.9.85-.94-.04-.04-.53.39-1.17.8-1.16.74-1.75.69-3.14 1.29-1.16.5-1.98 1.06-2.25 1.26-.69.48-1.4 1.12-2.83 2.38-.68.6-1.03.93-1.63 1.02-.69.1-1.3-.18-1.66-.41 0 0-.85-1.24-.5-1.92.26-.51 1.53-1.73 1.11-1.33.25-.26.64-.66 1.17-1.11.83-.7 1.3-.95 1.98-1.46 1.34-1.02 1.01-1.24 2.01-1.94 1.5-1.05 3.61-1.53 3.73-1.55.26-.06.86-.18 1.42-.63.53-.42.8-.96.76-1-.05-.04-.44.51-1.26.94-.06.03-.36.19-.7.3-1.17.36-1.56-.32-2.81-.15-.72.1-.89.37-2.05.52-.41.05-.4.02-.68.06-1.36.18-1.71.92-3.22 1.39-.58.18-1.06.32-1.63.15-.1-.03-.93-.3-1.13-.98-.3-.76-.17-1.36.44-1.79 0 0 1.27-.61 2.4-1.13 1.34-.62 1.29-.55 2.33-1.03 2.06-.95 1.87-1.01 2.4-1.15 1.33-.34 1.57.25 3.7.26 1.58 0 1.81-.31 3.4-.26 1.11.04 2.01.22 2.57.37 0 0 3.7 1.06 4.96 2.2 4.03 3.24 5.77 8.21 5.79 8.49Z"
        style={{
          fill: "#db9f6a",
        }}
      />
      <path
        d="M87.86 93.07c.97-.71 2.12-1.13 3.29-1.4 1.17-.26 2.39-.35 3.58-.11-2.32.52-4.53 1.01-6.87 1.51Z"
        style={{
          fill: "#101010",
        }}
      />
      <path
        d="M91.3 92.03c.24-1.04 1.35-2.48 2.49-2.5-.77.92-1.41 1.91-2.49 2.5Z"
        style={{
          fill: "#101010",
        }}
      />
      <ellipse
        cx={44.9}
        cy={101.3}
        rx={1.92}
        ry={1.76}
        style={{
          fill: "#1e1c1d",
        }}
      />
      <ellipse
        cx={45.02}
        cy={101.19}
        rx={1.4}
        ry={1.28}
        style={{
          fill: "#101010",
        }}
      />
      <circle
        cx={44.75}
        cy={100.9}
        r={0.18}
        style={{
          fill: "#1e1c1d",
        }}
      />
      <circle
        cx={45.34}
        cy={100.81}
        r={0.18}
        style={{
          fill: "#1e1c1d",
        }}
      />
      <circle
        cx={45.49}
        cy={101.42}
        r={0.18}
        style={{
          fill: "#1e1c1d",
        }}
      />
      <circle
        cx={44.87}
        cy={101.59}
        r={0.18}
        style={{
          fill: "#1e1c1d",
        }}
      />
    </g>
  </svg>
);
